import edjsHTML from 'editorjs-html'
import functions from './parsingFunctions'

const parserObj = {}
Object.keys(functions).forEach(func => {
  const parser = functions[func]
  parserObj[func] = parser
})

const edjs = edjsHTML(parserObj)

export default edjs
